<template>
  <div class="grid-view">
    <div class="main-content">
      <div v-show="pageMode === 0" style="width: 100%; height: 100%">
        <bank-slip-query
          ref="bankSlipWriteOff"
          identify="bankSlipWriteOff"
          view-source="bankSlipWriteOff"
          config-module="1200"
          :is-ar="searchConditions.applicationStatus"
          :is-claim="true"
          :check-role="false"
          :ar-field="'ar'"
          :total-type="'revenueAbs'"
          :page-mode="pageMode"
          grid-config-module="1200002"
        >
          <div slot="operations">
            <!--应收款认领-->
            <el-button v-show="$checkPermission(['button_fmBankSlip_bankSlipWriteOff'])" type="primary" @click="writeOffClickHandler">{{ $t('CargoMsg.Cargo_ClaimAR') }}</el-button>
            <!--预收款认领-->
            <el-button v-show="$checkPermission(['button_fmBankSlip_bankSlipWriteOff'])" type="primary" @click="preWriteOffClickHandler">{{ $t('CargoMsg.Cargo_ClaimAdvanceReceipt') }}</el-button>
          </div>
          <template v-slot:searchAreaHeader>
            <div class="app-main-inner-row  extension-conditions-form" style="padding-bottom: 5px;margin-top: -7px">
              <div class="filters">
                <el-form :inline="true" label-position="left">
                  <div class="el-form-item-wrapper dense-radio-group">
                    <el-form-item :label="$t('CargoMsg.Cargo_PaymentReceiveMethod')" class="dense-radio-group">
                      <el-radio-group v-model="searchConditions.applicationStatus">
                        <el-radio :disabled="!(bankArSlip && bankApSlip)" :label="-1">{{ $t('CargoMsg.Cargo_All') }}</el-radio>
                        <el-radio :disabled="!bankArSlip" :label="1">{{ $t('CargoMsg.Cargo_Receivable') }}</el-radio>
                        <el-radio :disabled="!bankApSlip" :label="0">{{ $t('CargoMsg.Cargo_Dues') }}</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </el-form>
              </div>
            </div>
          </template>
        </bank-slip-query>
      </div>
      <div v-show="pageMode !== 0" style="width: 100%; height: 100%">
        <el-form
          ref="form"
          :model="form"
          label-width="100px"
          style="width: 100%; height: 100%"
          label-position="left"
          :show-message="false"
        >
          <el-collapse style="width: 100%; height: 100%">
            <div style="width:100%;height: 100%; min-width:1000px;display: flex;flex-direction: column;">
              <!--        水单详情-->
              <div class="section" style="width:100%;min-height: 120px">
                <span class="title">{{ $t('CargoMsg.Cargo_BankReceiptDetails') }}</span>
                <div class="form-row" style="flex-direction:row;">
                  <el-form
                    label-width="100px"
                    label-position="left"
                    :disabled="true"
                    style="margin-right:10px"
                  >
                    <el-row>
                      <el-col :span="5">
                        <el-form-item
                          :label="$t('CargoMsg.Cargo_SerialNoOfBankReceipt')"
                          prop="actualAmountNo"
                        >
                          <el-input v-model="form.actualAmountNo" class="input-i" />
                        </el-form-item>

                        <el-form-item
                          :label="$t('CargoMsg.Cargo_PaymentCompanyName')"
                          prop="paymentCompany"
                        >
                          <el-input v-model="form.paymentCompany" class="input-i" />
                        </el-form-item>

                        <el-form-item
                          :label="$t('CargoMsg.Cargo_CompanySReceivingBank')"
                          prop="companyBank"
                        >
                          <el-input v-model="form.companyBank" class="input-i" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="5">
                        <el-form-item
                          :label="$t('CargoMsg.Cargo_PublishStatus')"
                          prop="releaseState"
                        >
                          <el-input v-model="form.releaseState" class="input-i" />
                        </el-form-item>

                        <el-form-item
                          :label="$t('CargoMsg.Cargo_CurrencyOfPayment')"
                          prop="currency"
                        >
                          <el-input v-model="form.currency" class="input-i" />
                        </el-form-item>

                        <el-form-item
                          :label="$t('CargoMsg.Cargo_CompanySReceivingAccountNumber')"
                          prop="companyBankAccount"
                        >
                          <el-input v-model="form.companyBankAccount" class="input-i" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="5">
                        <el-form-item
                          :label="$t('CargoMsg.Cargo_ClaimState')"
                          prop="labState"
                        >
                          <el-input v-model="form.labState" class="input-i" />
                        </el-form-item>
                        <el-form-item
                          :label="$t('CargoMsg.Cargo_PaymentAmount')"
                          prop="amount"
                        >
                          <el-input v-model="form.amount" class="input-i" />
                        </el-form-item>
                        <el-form-item
                          :label="$t('CargoMsg.Cargo_RemainingPledgedAmount')"
                          prop="remainAmount"
                        >
                          <el-input v-model="form.remainAmount" class="input-i" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
              <!--        认领信息-->
              <div class="section" style="padding: 6px 0 0 0;width:100%;flex-grow: 1">
                <span class="title">{{ $t('CargoMsg.Cargo_ClaimInformation') }}</span>
                <div class="form-row" style="width:100%; height: 100%">
                  <div v-show="pageMode === 1" style="height: 100%">
                    <bank-slip-charge-query
                      ref="bankSlipWriteOffCharge"
                      identify="bankSlipWriteOff"
                      view-source="bankSlipWriteOff"
                      job-state-param="WriteoffJobState"
                      charge-state-param="WriteoffChargeState"
                      confirm-state-param="WriteoffChargeConfirmState"
                      config-module="1300"
                      :is-ar="searchConditions.applicationStatus"
                      :oversea="searchConditions.oversea"
                      :paid-off="0"
                      :show-billing-no="true"
                      :show-invoice-no="true"
                      :show-total-unverified-amount="true"
                      :show-unverified-amount="true"
                      :rate-field="'rate'"
                      :ar-field="'isReceivable'"
                      :total-type="'revenueAbs'"
                      grid-config-module="1300001"
                    >
                      <div slot="operations">
                        <!--认领-->
                        <el-button type="primary" @click="bankSlipClickEvent">{{ $t('CargoMsg.Cargo_Claim') }}</el-button>
                        <!--返回-->
                        <el-button type="primary" @click="backClickHandler">{{ $t('CargoMsg.Cargo_Back') }}</el-button>
                      </div>
                      <template v-slot:searchAreaHeader>
                        <div class="app-main-inner-row  extension-conditions-form" style="padding-bottom: 5px;margin-top: -7px">
                          <div class="filters">
                            <el-form :inline="true" label-width="60px" label-position="left">
                              <div class="el-form-item-wrapper dense-radio-group">
                                <el-form-item :label="$t('CargoMsg.Cargo_PaymentReceiveMethod')" class="dense-radio-group">
                                  <el-radio-group v-model="searchConditions.applicationStatus">
                                    <el-radio :disabled="!(bankArSlip && bankApSlip)" :label="-1">{{ $t('CargoMsg.Cargo_All') }}</el-radio>
                                    <el-radio :disabled="!bankArSlip" :label="1">{{ $t('CargoMsg.Cargo_Receivable') }}</el-radio>
                                    <el-radio :disabled="!bankApSlip" :label="0">{{ $t('CargoMsg.Cargo_Dues') }}</el-radio>
                                  </el-radio-group>
                                </el-form-item>

                                <el-form-item :label="$t('CargoMsg.Cargo_ChargeType')" class="dense-radio-group">
                                  <el-radio-group v-model="searchConditions.oversea">
                                    <el-radio :label="-1">{{ $t('CargoMsg.Cargo_All') }}</el-radio>
                                    <el-radio :label="0">{{ $t('CargoMsg.Cargo_Domestic') }}</el-radio>
                                    <el-radio :label="1">{{ $t('CargoMsg.Cargo_International') }}</el-radio>
                                  </el-radio-group>
                                </el-form-item>

                                <el-form-item :label="$t('CargoMsg.Cargo_MethodOfClaim')" class="dense-radio-group">
                                  <el-radio-group v-model="searchConditions.mode" @change="modeChangeHandler">
                                    <el-radio :label="0">{{ $t('CargoMsg.Cargo_Cost') }}</el-radio>
                                    <el-radio :label="1">{{ $t('CargoMsg.Cargo_Bill') }}</el-radio>
                                    <el-radio :label="2">{{ $t('CargoMsg.Cargo_Invoice') }}</el-radio>
                                  </el-radio-group>
                                </el-form-item>
                              </div>
                            </el-form>
                          </div>
                        </div>
                      </template>
                    </bank-slip-charge-query>
                  </div>
                  <div v-show="pageMode === 2" style="height: 100%">
                    <bank-slip-billing-query
                      ref="bankSlipWriteOffBilling"
                      identify="bankSlipWriteOff"
                      view-source="bankSlipWriteOff"
                      config-module="1400"
                      billing-clearing-state-param="WriteoffBillingClearingState"
                      billing-job-state-param="WriteoffJobState"
                      billing-state-param="WriteoffBillingState"
                      :clearing-state="0"
                      :is-ar="searchConditions.applicationStatus"
                      :oversea="searchConditions.oversea"
                      :show-real-clearing-state="true"
                      :show-total-unverified-amount="true"
                      :ar-field="'ar'"
                      :total-type="'revenueAbs'"
                      :page-mode="pageMode"
                      grid-config-module="1400001"
                    >
                      <div slot="operations">
                        <!--认领-->
                        <el-button type="primary" @click="bankSlipClickEvent">{{ $t('CargoMsg.Cargo_Claim') }}</el-button>
                        <!--返回-->
                        <el-button type="primary" @click="backClickHandler">{{ $t('CargoMsg.Cargo_Back') }}</el-button>
                      </div>
                      <template v-slot:searchAreaHeader>
                        <div class="app-main-inner-row  extension-conditions-form" style="padding-bottom: 5px;margin-top: -7px">
                          <div class="filters">
                            <el-form :inline="true" label-width="60px" label-position="left">
                              <div class="el-form-item-wrapper dense-radio-group">
                                <el-form-item :label="$t('CargoMsg.Cargo_PaymentReceiveMethod')" class="dense-radio-group">
                                  <el-radio-group v-model="searchConditions.applicationStatus">
                                    <el-radio :disabled="!(bankArSlip && bankApSlip)" :label="-1">{{ $t('CargoMsg.Cargo_All') }}</el-radio>
                                    <el-radio :disabled="!bankArSlip" :label="1">{{ $t('CargoMsg.Cargo_Receivable') }}</el-radio>
                                    <el-radio :disabled="!bankApSlip" :label="0">{{ $t('CargoMsg.Cargo_Dues') }}</el-radio>
                                  </el-radio-group>
                                </el-form-item>
                                <el-form-item :label="$t('CargoMsg.Cargo_ChargeType')" class="dense-radio-group">
                                  <el-radio-group v-model="searchConditions.oversea">
                                    <el-radio :label="-1">{{ $t('CargoMsg.Cargo_All') }}</el-radio>
                                    <el-radio :label="0">{{ $t('CargoMsg.Cargo_Domestic') }}</el-radio>
                                    <el-radio :label="1">{{ $t('CargoMsg.Cargo_International') }}</el-radio>
                                  </el-radio-group>
                                </el-form-item>

                                <el-form-item :label="$t('CargoMsg.Cargo_MethodOfClaim')" class="dense-radio-group">
                                  <el-radio-group v-model="searchConditions.mode" @change="modeChangeHandler">
                                    <el-radio :label="0">{{ $t('CargoMsg.Cargo_Cost') }}</el-radio>
                                    <el-radio :label="1">{{ $t('CargoMsg.Cargo_Bill') }}</el-radio>
                                    <el-radio :label="2">{{ $t('CargoMsg.Cargo_Invoice') }}</el-radio>
                                  </el-radio-group>
                                </el-form-item>
                              </div>
                            </el-form>
                          </div>
                        </div>
                      </template>
                    </bank-slip-billing-query>
                  </div>
                  <div v-show="pageMode === 3" style="height: 100%; display: flex; flex-direction: column;">
                    <bank-slip-invoice-query
                      ref="bankSlipWriteOffInvoice"
                      identify="bankSlipWriteOff"
                      view-source="bankSlipWriteOff"
                      config-module="1401"
                      billing-clearing-state-param="WriteoffBillingClearingState"
                      billing-job-state-param="WriteoffJobState"
                      billing-state-param="WriteoffBillingState"
                      :clearing-state="0"
                      :is-ar="searchConditions.applicationStatus"
                      :oversea="searchConditions.oversea"
                      :show-real-clearing-state="true"
                      :show-total-unverified-amount="true"
                      :total-type="'auto'"
                      :page-mode="pageMode"
                      grid-config-module="190606"
                      :invoice-no-state="1"
                      :show-charge-count="true"
                      :show-unverified-amount="true"
                      :show-fba="false"
                      :always-show="false"
                      :new-currency-code="true"
                      :show-wht="true"
                      type="both"
                    >
                      <div slot="operations">
                        <!--认领-->
                        <el-button type="primary" @click="bankSlipClickEvent">{{ $t('CargoMsg.Cargo_Claim') }}</el-button>
                        <!--返回-->
                        <el-button type="primary" @click="backClickHandler">{{ $t('CargoMsg.Cargo_Back') }}</el-button>
                      </div>
                      <template v-slot:searchAreaHeader>
                        <div class="app-main-inner-row  extension-conditions-form" style="padding-bottom: 5px;margin-top: -7px">
                          <div class="filters">
                            <el-form :inline="true" label-width="60px" label-position="left">
                              <div class="el-form-item-wrapper dense-radio-group">
                                <el-form-item :label="$t('CargoMsg.Cargo_PaymentReceiveMethod')" class="dense-radio-group">
                                  <el-radio-group v-model="searchConditions.applicationStatus">
                                    <el-radio :disabled="!(bankArSlip && bankApSlip)" :label="-1">{{ $t('CargoMsg.Cargo_All') }}</el-radio>
                                    <el-radio :disabled="!bankArSlip" :label="1">{{ $t('CargoMsg.Cargo_Receivable') }}</el-radio>
                                    <el-radio :disabled="!bankApSlip" :label="0">{{ $t('CargoMsg.Cargo_Dues') }}</el-radio>
                                  </el-radio-group>
                                </el-form-item>
                                <el-form-item :label="$t('CargoMsg.Cargo_MethodOfClaim')" class="dense-radio-group">
                                  <el-radio-group v-model="searchConditions.mode" @change="modeChangeHandler">
                                    <el-radio :label="0">{{ $t('CargoMsg.Cargo_Cost') }}</el-radio>
                                    <el-radio :label="1">{{ $t('CargoMsg.Cargo_Bill') }}</el-radio>
                                    <el-radio :label="2">{{ $t('CargoMsg.Cargo_Invoice') }}</el-radio>
                                  </el-radio-group>
                                </el-form-item>
                              </div>
                            </el-form>
                          </div>
                        </div>
                      </template>
                    </bank-slip-invoice-query>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse>
        </el-form>
      </div>
    </div>

    <bank-slip-window
      :visible.sync="bankSlipWindow.visible"
      :is-pre-payment="bankSlipWindow.isPrePayment"
      :params="bankSlipWindow.params"
      :ar="true"
      @refresh="refreshPageHandler"
    />
    <!--    销账-->
    <write-off-dialog v-if="writeOffDialog.visible" ref="dgWriteOff" :location="location" :visible.sync="writeOffDialog.visible" :title="writeOffDialog.title" :params="writeOffDialog.params" :properties="writeOffDialog.properties" @writeoffSuccessHandler="writeOffSuccessHandler" />
  </div>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { DocumentManage } from '@/utils/commonUtil'
import BankSlipWindow from '@/views/cargo/v0/Clearing/components/bankSlip/bankSlipWindow'
import BankSlipQuery from '@/views/cargo/v0/Clearing/components/bankSlip/bankSlipQuery'
import BankSlipChargeQuery from '@/views/cargo/v0/Clearing/components/bankSlip/bankSlipChargeQuery'
import BankSlipBillingQuery from '@/views/cargo/v0/Clearing/components/bankSlip/bankSlipBillingQuery'
import checkPermission from '@/utils/permission'
import * as actualAmountApi from '@/api/clearing/actualAmount'
import { BANK_SLIP_STATES_ALL, getClearingBankSlipByCode, BANK_SLIP_RETURN_APPLY_STATE_PENDING, RECEIVE_TYPE_REFUND } from '@/class/cargo/model/parameters/ClearingConstants'
import * as writeoffApi from '@/api/act/writeoff'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import { getLoading } from '@/utils/utilBaseElement'
import writeOffDialog from '@/views/cargo/v0/Clearing/components/Writeoff/writeOffDialog'
import { getNotWriteoffCharges } from '@/api/clearing/actualAmount'
import ColumnUtils from '@/utils/ColumnUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { LOG_CLAIM_BANK_RECEIPT } from '@/class/cargo/model/parameters/SystemConstants'
import * as NumberUtils from '@/utils/NumberUtils'
import BankSlipInvoiceQuery from '@/views/cargo/v0/Clearing/components/bankSlip/bankSlipInvoiceQuery.vue'
import QueryInvoice from '@/views/cargo/v0/Clearing/components/query/queryInvoice.vue'

export default {
  name: 'BankSlipWriteOff',
  components: {
    QueryInvoice,
    BankSlipInvoiceQuery,
    BankSlipChargeQuery,
    BankSlipBillingQuery,
    BankSlipQuery,
    BankSlipWindow,
    searchItem,
    writeOffDialog
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      documentManage: new DocumentManage(),
      searchConditions: {
        applicationStatus: -1,
        oversea: -1,
        mode: 0
      },
      gridApi: null,
      pageMode: 0,
      bankArSlip: false,
      bankApSlip: false,
      showClaim: false,
      form: {
        model: null,
        checkAccountId: 0,
        actualAmountNo: '',
        paymentCompany: '',
        companyBank: '',
        releaseState: '',
        currency: '',
        companyBankAccount: '',
        labState: '',
        amount: '',
        remainAmount: ''
      },
      bankSlipWindow: {
        visible: false,
        isPrePayment: false,
        params: null,
        title: ''
      },
      writeOffDialog: {
        visible: false,
        title: '',
        params: {},
        properties: {}
      },
      location: LOG_CLAIM_BANK_RECEIPT.code
    }
  },
  computed: {},
  async created() {
    await this.preloadBasicData()
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.office = cache.office
    this.bankArSlip = checkPermission(['role_fmBankSlip_bankArSlip'])
    this.bankApSlip = checkPermission(['role_fmBankSlip_bankApSlip'])
    if (this.bankArSlip && !this.bankApSlip) {
      this.searchConditions.applicationStatus = 1
    } else if (!this.bankArSlip && this.bankApSlip) {
      this.searchConditions.applicationStatus = 0
    } else {
      this.searchConditions.applicationStatus = -1
    }
    this.searchConditions.jobStateParam = String(cache.config.get('WriteoffJobState'))
  },
  beforeMount() {

  },
  beforeDestroy() {

  },
  methods: {
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
    },
    // 分页查询
    refreshPageHandler() {
      this.$refs.bankSlipWriteOff.refreshPageHandler()
    },
    // 应收款认领
    writeOffClickHandler() {
      this.selectedData = this.$refs.bankSlipWriteOff.selectedData
      if (!this.selectedData || !this.selectedData.uuid) {
        this.$message.warning(this.$t('Clearing.WaterBillNotSelected'))
        return
      } else if (this.selectedData.type === RECEIVE_TYPE_REFUND.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_WaterRefundedNoWriteOff'))
        return
      } else if (this.selectedData.returnApplyState === BANK_SLIP_RETURN_APPLY_STATE_PENDING.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_WaterRefundingNoWriteOff'))
        return
      }
      if (this.selectedData.preBankSlipState > 0) {
        actualAmountApi.checkPreActCreateVoucherFunc({ actKey: this.selectedData.uuid }).then(resp => {
          const flag = resp.data
          if (!flag) {
            this.$message.warning(this.$t('Clearing.AdvanceNoAdvancePaymentGenerated'))
            return
          }
          this.continueCreateVoucherHandler()
        }).catch((err) => {
          this.$message.error(err)
          this.loading.close()
        })
      } else {
        this.continueCreateVoucherHandler()
      }
    },
    continueCreateVoucherHandler(data = null) {
      if (this.pageMode === 0) {
        this.pageMode = 1
      }
      let d = this.selectedData
      if (data) {
        d = this.selectedData = data
        const index = this.$refs.bankSlipWriteOff.rowData.findIndex(row => {
          return row.uuid === d.uuid
        })
        const bankSlipWriteOffRowData = this.$refs.bankSlipWriteOff.rowData
        Object.keys(this.selectedData).forEach((key) => {
          bankSlipWriteOffRowData[index][key] = this.selectedData[key]
        })
        this.$refs.bankSlipWriteOff.rowData = [...bankSlipWriteOffRowData]
      }
      this.form = {}
      this.form.model = d
      this.form.actualAmountNo = d.actualAmountNo
      this.form.paymentCompany = d.paymentCompany
      this.form.companyBank = d.companyBank
      this.form.releaseState = d.releaseState
      this.form.currency = d.currency
      this.form.companyBankAccount = d.companyBankAccount
      const releaseState = getClearingBankSlipByCode(d.bankSlipState, BANK_SLIP_STATES_ALL)
      this.form.labState = releaseState.chineseName
      this.form.amount = ColumnUtils.formatNumber(d.amount, 2, true)
      // 剩余金额
      d.remainAmount = NumberUtils.ToFixed2(d.remainAmount - d.returnAmount, 2)
      if (d.remainAmount === 0) {
        this.form.remainAmount = '已认领'
      } else {
        this.form.remainAmount = ColumnUtils.formatNumber(d.remainAmount, 2, true)
      }
    },
    // 预收款认领
    preWriteOffClickHandler() {
      this.selectedData = this.$refs.bankSlipWriteOff.selectedData
      if (!this.selectedData || !this.selectedData.uuid) {
        this.$message.warning(this.$t('Clearing.WaterBillNotSelected'))
        return
      } else if (this.selectedData.type === RECEIVE_TYPE_REFUND.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_WaterRefundedNoWriteOff'))
        return
      } else if (this.selectedData.returnApplyState === BANK_SLIP_RETURN_APPLY_STATE_PENDING.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_WaterRefundingNoWriteOff'))
        return
      }
      if (this.selectedData.bankSlipState > 0) {
        this.$message.warning(this.$t('Clearing.ReceivableClaimCompleted'))
        return
      }
      if (this.selectedData.preBankSlipState > 0) {
        this.$message.warning(this.$t('Clearing.PrepaymentClaimCompleted'))
        return
      }
      this.loading = getLoading()
      this.filterJson = {}
      this.filterJson.conditions = []
      this.filterJson.conditions.push(new AdvancedSearchOption(null, 'actualAmount.UUID', this.selectedData.uuid, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      this.filterJson.pageNum = 1
      this.filterJson.pageSize = 1
      writeoffApi.queryActualAmountPageable(this.filterJson).then(res => {
        this.loading.close()
        if (res && res.data && res.data.list.length > 0) {
          this.bankSlipWindow.params = res.data.list[0]
          this.bankSlipWindow.title = this.$t('CargoMsg.Cargo_ClaimAdvanceReceipt')
          this.bankSlipWindow.isPrePayment = true
          this.bankSlipWindow.visible = true
        }
      }).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    getSelections() {
      let selections = []
      if (this.pageMode === 1) {
        selections = this.$refs.bankSlipWriteOffCharge.selectedDataList
      } else if (this.pageMode === 2) {
        selections = this.$refs.bankSlipWriteOffBilling.selectedDataList
      } else if (this.pageMode === 3) {
        console.log('Getting invoice selections...')
        if (this.$refs.bankSlipWriteOffInvoice) {
          console.log('Invoice component found')
          selections = this.$refs.bankSlipWriteOffInvoice.getSelections()
          console.log('Selected rows:', selections)
        } else {
          console.log('Invoice component not found')
        }
      }
      return selections
    },
    async bankSlipClickEvent() {
      console.log('开始认领操作...')
      console.log('当前 pageMode:', this.pageMode)
      if (this.form.model.remainAmount === 0) {
        this.$message.warning(this.$t('Clearing.NoInTheCurrentBill'))
        return
      }
      const selections = this.getSelections()
      console.log('获取到的选中数据:', selections)
      if (selections.length === 0) {
        this.$message.warning(this.$t('Clearing.PleaseDataToBeClaimed'))
        return
      }
      this.checkAccountId = 0
      for (const obj of selections) {
        if (this.checkAccountId > 0 && this.checkAccountId !== obj.accountId) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SettlingCompanyMustBeIdentical'))
          return
        }
        this.checkAccountId = obj.accountId
      }
      this.loading = getLoading()
      this.filterJson = {}
      this.filterJson.conditions = []
      this.filterJson.conditions.push(new AdvancedSearchOption(null, 'actualAmount.UUID', this.form.model.uuid, AdvancedSearchConsts.OPERATOR_EQUAL.code))
      this.filterJson.pageNum = 1
      this.filterJson.pageSize = 1
      // 重新查询，取最新数据
      await writeoffApi.queryActualAmountPageable(this.filterJson).then(res => {
        this.loading.close()
        if (res && res.data && res.data.list.length > 0) {
          this.writeOffHandler(res.data.list[0])
        }
      }).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 认领 页面数据封装
    async writeOffHandler(model) {
      // 使用实收实付
      const selections = this.getSelections()
      const ar = selections[0].ar
      // 实收实付没有结算单位，将选中数据代入
      if (model.accountId <= 0) {
        model.accountId = this.checkAccountId
      }
      // 销账模式
      this.writeOffDialog.title = this.$t('CargoMsg.Cargo_WriteOff')
      this.writeOffDialog.properties.mode = 0
      if (this.pageMode === 1) {
        // 按费用销账
        this.writeOffDialog.properties.writeOffMode = 1
      } else if (this.pageMode === 2) {
        // 按账单销账
        this.writeOffDialog.properties.writeOffMode = 3
      } else if (this.pageMode === 3) {
        // 按发票销账
        this.writeOffDialog.properties.writeOffMode = 2
      }
      this.writeOffDialog.properties.accountId = this.checkAccountId
      this.writeOffDialog.properties.selectedEntitiesOrigin = selections
      this.writeOffDialog.properties.selectedEntities = selections
      this.writeOffDialog.properties.allEntities = []
      this.writeOffDialog.properties.isEntitiesAr = ar
      this.writeOffDialog.properties.actualAmount = model
      this.writeOffDialog.properties.rpDate = new Date()
      this.writeOffDialog.properties.isHedge = false
      const localCurrency = RateUtil.localCurrencyByOffice()
      this.writeOffDialog.properties.defaultCurrency = localCurrency
      this.writeOffDialog.properties.entities = []
      const keys = []
      for (const item of this.writeOffDialog.properties.selectedEntities) {
        keys.push(item.uuid)
      }
      if (keys.length === 0) return
      const requestBody = { 'keys': keys, 'classType': this.classType(), 'isOversea': this.searchConditions.oversea, 'officeId': this.$store.getters.currentOfficeId }
      this.loading = getLoading()
      await getNotWriteoffCharges(requestBody).then(res => {
        this.writeOffDialog.properties.entities = res.data
      }).finally(() => {
        this.loading.close()
      })
      this.writeOffDialog.properties.allEntities.push(...this.writeOffDialog.properties.entities)
      this.writeOffDialog.properties.currencys = []
      for (const c of this.writeOffDialog.properties.allEntities) {
        if (this.writeOffDialog.properties.currencys.indexOf(c.currency) === -1) {
          this.writeOffDialog.properties.currencys.push(c.currency)
        }
      }
      if (this.writeOffDialog.properties.entities.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoExpenseToWriteOff'))
        return
      }
      // 按费用销账：组合列表
      if (this.searchConditions.mode === 1) {
        this.writeOffDialog.properties.chargeAccountIds = []
        const selectedEntitiesNew = []
        for (const charge of this.writeOffDialog.properties.selectedEntities) {
          if (this.writeOffDialog.properties.chargeAccountIds.indexOf(charge.accountId) === -1) {
            this.writeOffDialog.properties.chargeAccountIds.push(charge.accountId)
            selectedEntitiesNew.push(charge)
          }
        }
        this.writeOffDialog.properties.selectedEntities = selectedEntitiesNew
      }
      this.writeOffDialog.properties.bankSlip = true
      this.writeOffDialog.properties.actualAmount = model
      this.writeOffDialog.properties.otherCurrencyRate = []
      this.writeOffDialog.visible = true
    },
    classType() {
      if (this.pageMode === 1) {
        return 'charge'
      }
      if (this.pageMode === 2) {
        return 'billing'
      }
      if (this.pageMode === 3) {
        return 'invoice'
      }
    },
    backClickHandler() {
      this.pageMode = 0
      this.applicationStatus = -1
      this.oversea = -1
      this.searchConditions.mode = 0
    },
    modeChangeHandler() {
      if (this.searchConditions.mode === 0) {
        this.pageMode = 1
      }
      if (this.searchConditions.mode === 1) {
        this.pageMode = 2
      }
      if (this.searchConditions.mode === 2) {
        this.pageMode = 3
      }
      if (this.bankArSlip && !this.bankApSlip) {
        this.searchConditions.applicationStatus = 1
      } else if (!this.bankArSlip && this.bankApSlip) {
        this.searchConditions.applicationStatus = 0
      } else {
        this.searchConditions.applicationStatus = -1
      }
    },
    writeOffSuccessHandler() {
      if (this.pageMode === 1) {
        this.$refs.bankSlipWriteOffCharge.refreshPageHandler()
      }
      if (this.pageMode === 2) {
        this.$refs.bankSlipWriteOffBilling.refreshPageHandler()
      }
      if (this.pageMode === 3) {
        this.$refs.bankSlipWriteOffInvoice.fetchDataByPage()
      }
      if (this.selectedData && this.selectedData.uuid) {
        this.loading = getLoading()
        this.filterJson = {}
        this.filterJson.conditions = []
        this.filterJson.conditions.push(new AdvancedSearchOption(null, 'actualAmount.UUID', this.selectedData.uuid, AdvancedSearchConsts.OPERATOR_EQUAL.code))
        this.filterJson.pageNum = 1
        this.filterJson.pageSize = 1
        writeoffApi.queryActualAmountPageable(this.filterJson).then(res => {
          this.loading.close()
          if (res && res.data && res.data.list.length > 0) {
            this.continueCreateVoucherHandler(res.data.list[0])
          }
        }).catch((err) => {
          this.$message.error(err)
          this.loading.close()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.section .form-row::v-deep {
  .pagination-wrapper {
    background-color: #e2e8f3;
  }
}
.input-i {
  padding-right: 20px
}
</style>
<style scoped>
.section .title {
    display: inline-block;
    position: relative;
    font-size: 13px;
    padding-left: 15px;
    line-height: 14px;
    margin-bottom: 10px;
}
.section .title:before {
    content: '';
    position: absolute;
    width: 4px;
    top: 0;
    left: 0;
    bottom: 0;
    background-color: #1F75D5;
}
</style>
